// Helpers for the TCP+ per-sync result list shown in the employee sidebar.

// Count of updated EJCs that actually carry a change (TC+ can return an
// "updated" entry with an empty updates dict, which is a no-op).
export function tcpplusUpdatedCount(r) {
    return (r.updated || []).filter(
        u => u.updates && Object.keys(u.updates).length,
    ).length
}

// A result is a no-op when nothing happened: no EE created/suspended, no EJCs
// created/updated/deactivated, and no warnings or errors to surface.
export function isTCPPlusResultNoop(r) {
    return (
        !r.employee_created &&
        !r.suspended &&
        !(r.created && r.created.length) &&
        !tcpplusUpdatedCount(r) &&
        !(r.deactivated && r.deactivated.length) &&
        !(r.warnings && r.warnings.length) &&
        !(r.errors && r.errors.length)
    )
}

// Drop no-op results so the sidebar only lists syncs that changed something.
export function visibleTCPPlusResults(results) {
    return (results || []).filter(r => !isTCPPlusResultNoop(r))
}

// A persisted TCP+ history row (POSDataUpdate) is a no-op when it's a
// "reconcile" whose stored api_response shows nothing changed. Only reconcile
// rows are eligible — hire/terminate/transfer rows always stay visible. The
// backend stopped recording new no-op reconciles, but older rows already in
// the DB are hidden here too. Mirrors isTCPPlusResultNoop.
export function isTCPPlusUpdateNoop(u) {
    return u.action === 'reconcile' && isTCPPlusResultNoop(u.api_response || {})
}

// Drop no-op reconcile rows so the history table only lists rows that mattered.
export function visibleTCPPlusUpdates(updates) {
    return (updates || []).filter(u => !isTCPPlusUpdateNoop(u))
}
